// // import React, { useEffect, useState } from 'react';
// // import { IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonSpinner, IonCardContent } from '@ionic/react';

// // const RotatingCanadianNews = ({ interval = 5000 }) => {
// //     const [news, setNews] = useState([]);
// //     const [currentIndex, setCurrentIndex] = useState(0);
// //     const [loading, setLoading] = useState(true);
// //     const keywords = [
// //         "canada", "alberta", "british columbia", "manitoba", "new brunswick",
// //         "newfoundland", "nova scotia", "ontario", "prince edward island",
// //         "quebec", "saskatchewan", "yukon", "nunavut", "northwest territories",
// //         // "bc", "pei", "nb", "nl", "ns", "qc", "sk", "ab", "mb", "yt", "nt", "nu"
// //     ];
// //     const feeds = [
// //         "https://news.google.com/rss?hl=en-CA&gl=CA&ceid=CA:en",
// //         "https://www.cbc.ca/cmlink/rss-topstories",
// //         "https://globalnews.ca/canada/feed/",
// //         "https://www.ctvnews.ca/rss/ctvnews-ca-canada-public-rss-1.822284"
// //     ];

// //     useEffect(() => {
// //         const fetchRSS = async () => {
// //             try {
// //                 const rssUrl = "https://api.rss2json.com/v1/api.json?rss_url=https://news.google.com/rss?hl=en-CA&gl=CA&ceid=CA:en";
// //                 const response = await fetch(rssUrl);
// //                 const data = await response.json();

// //                 const items = data.items
// //                     .filter(item =>
// //                         keywords.some(keyword => item.title.toLowerCase().includes(keyword))
// //                     )
// //                     .slice(0, 20)
// //                     .map(item => ({
// //                         title: item.title,
// //                         date: new Date(item.pubDate).toLocaleDateString(),
// //                     }));
// //                 console.log(items)
// //                 setNews(items);
// //             } catch (error) {
// //                 console.error("Error fetching RSS:", error);
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };

// //         fetchRSS();
// //     }, []);

// //     // Rotate news index AFTER news is loaded
// //     useEffect(() => {
// //         if (news.length === 0) return; // wait until we have news
// //         const timer = setInterval(() => {
// //             setCurrentIndex(prev => (prev + 1) % news.length);
// //         }, interval);

// //         return () => clearInterval(timer); // cleanup
// //     }, [news, interval]); // depend on news length

// //     if (loading) return <IonSpinner style={{ margin: "20px auto", display: "block" }} />;

// //     if (!news.length) return <p style={{ textAlign: 'center' }}>No Canadian news available.</p>;

// //     const currentNews = news[currentIndex];

// //     return (
// //         <div className="post__side--right post">
// //             <IonCard color="light" className="post-card ion-no-margin ion-shadow-sm">
// //                 <IonCardContent className="ion-padding">
// //                     <IonCardHeader>
// //                         <IonCardTitle>{currentNews.title}</IonCardTitle>
// //                         <IonCardSubtitle>{currentNews.date}</IonCardSubtitle>
// //                     </IonCardHeader>
// //                 </IonCardContent>
// //             </IonCard>
// //         </div>
// //     );
// // };

// // export default RotatingCanadianNews;
// import React, { useEffect, useState } from 'react';
// import { IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonSpinner, IonCardContent } from '@ionic/react';

// const RotatingCanadianNews = ({ interval = 5000 }) => {
//     const [news, setNews] = useState([]);
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [loading, setLoading] = useState(true);

//     const keywords = [
//         "canada", "alberta", "british columbia", "manitoba", "new brunswick",
//         "newfoundland", "nova scotia", "ontario", "prince edward island",
//         "quebec", "saskatchewan", "yukon", "nunavut", "northwest territories",
//     ];

//     const feeds = [
//         "https://news.google.com/rss?hl=en-CA&gl=CA&ceid=CA:en",
//         // "https://www.cbc.ca/cmlink/rss-topstories",
//         "https://globalnews.ca/canada/feed/",
//         // "https://www.ctvnews.ca/rss/ctvnews-ca-canada-public-rss-1.822284"
//     ];

//     useEffect(() => {
//         const fetchAllFeeds = async () => {
//             try {
//                 const allItems = [];

//                 // Loop through all feeds
//                 for (const feed of feeds) {
//                     const rssUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(feed)}`;
//                     const response = await fetch(rssUrl);
//                     const data = await response.json();
//                     console.log(data)
//                     if (data.items) {
//                         const filtered = data.items.filter(item =>
//                             keywords.some(keyword =>
//                                 item.title.toLowerCase().includes(keyword)
//                             )
//                         );
//                         allItems.push(...filtered);
//                     }
//                 }

//                 // Sort by date (newest first)
//                 allItems.sort((a, b) => new Date(b.pubDate) - new Date(a.pubDate));

//                 // Limit to first 20
//                 const topItems = allItems.slice(0, 20).map(item => ({
//                     title: item.title,
//                     date: new Date(item.pubDate).toLocaleDateString(),
//                 }));

//                 setNews(topItems);
//             } catch (error) {
//                 console.error("Error fetching RSS:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAllFeeds();
//     }, []);

//     // Rotate news
//     useEffect(() => {
//         if (news.length === 0) return;
//         const timer = setInterval(() => {
//             setCurrentIndex(prev => (prev + 1) % news.length);
//         }, interval);
//         return () => clearInterval(timer);
//     }, [news, interval]);

//     if (loading) return <IonSpinner style={{ margin: "20px auto", display: "block" }} />;
//     if (!news.length) return <p style={{ textAlign: 'center' }}>No Canadian news available.</p>;

//     const currentNews = news[currentIndex];

//     return (
//         <div className="post__side--right post">
//             <IonCard color="light" className="post-card ion-no-margin ion-shadow-sm">
//                 <IonCardContent className="ion-padding">
//                     <IonCardHeader>
//                         <IonCardTitle>{currentNews.title}</IonCardTitle>
//                         <IonCardSubtitle>{currentNews.date}</IonCardSubtitle>
//                     </IonCardHeader>
//                 </IonCardContent>
//             </IonCard>
//         </div>
//     );
// };

// export default RotatingCanadianNews;
// import React, { useEffect, useState } from 'react';
// import {
//     IonCard,
//     IonCardHeader,
//     IonCardTitle,
//     IonCardSubtitle,
//     IonSpinner,
//     IonCardContent
// } from '@ionic/react';
// import "./CanadianNews.css"
// const RotatingCanadianNews = ({ interval = 5000 }) => {
//     const [news, setNews] = useState([]);
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [loading, setLoading] = useState(true);

//     const keywords = [
//         "canada", "alberta", "british columbia", "manitoba", "new brunswick",
//         "newfoundland", "nova scotia", "ontario", "prince edward island",
//         "quebec", "saskatchewan", "yukon", "nunavut", "northwest territories",
//         "toronto", "vancouver", "montreal", "calgary", "edmonton",
//         "ottawa", "winnipeg", "halifax", "victoria", "regina",
//         "saskatoon", "st. john's", "charlottetown", "whitehorse",
//     ];
//     const feeds = [
//         "https://news.google.com/rss?hl=en-CA&gl=CA&ceid=CA:en",
//         "https://globalnews.ca/canada/feed/"
//     ];

//     useEffect(() => {
//         const fetchAllFeeds = async () => {
//             try {
//                 const allItems = [];

//                 for (const feed of feeds) {
//                     const rssUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(feed)}`;
//                     const response = await fetch(rssUrl);
//                     const data = await response.json();

//                     if (data.items) {
//                         const filtered = data.items.filter(item =>
//                             keywords.some(keyword =>
//                                 item.title.toLowerCase().includes(keyword)
//                             )
//                         );
//                         allItems.push(...filtered);
//                     }
//                 }

//                 allItems.sort((a, b) => new Date(b.pubDate) - new Date(a.pubDate));

//                 const topItems = allItems.slice(0, 20).map(item => ({
//                     title: item.title,
//                     date: new Date(item.pubDate).toLocaleDateString(),
//                 }));

//                 setNews(topItems);
//             } catch (error) {
//                 console.error("Error fetching RSS:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAllFeeds();
//     }, []);

//     useEffect(() => {
//         if (news.length === 0) return;
//         const timer = setInterval(() => {
//             setCurrentIndex(prev => (prev + 1) % news.length);
//         }, interval);
//         return () => clearInterval(timer);
//     }, [news, interval]);

//     if (loading) return <IonSpinner style={{ margin: "20px auto", display: "block" }} />;
//     if (!news.length) return <p style={{ textAlign: 'center' }}>No Canadian news available.</p>;

//     const currentNews = news[currentIndex];

//     return (
//         <div className="post__side--right post">
//             {/* <IonCard
//                 color="light"
//                 className="post-card ion-no-margin ion-shadow-sm"
//                 style={{
//                     height: "320px", // fixed card height
//                     display: "flex",
//                     alignItems: "center"
//                 }}
//             >
//                 <IonCardContent className="ion-padding" style={{ width: "100%" }}>
//                     <IonCardHeader>
//                         <IonCardTitle
//                             className="news-title"
//                             style={{
//                                 fontSize: Math.min(
//                                     50, // maximum font size for very short titles
//                                     40 - currentNews.title.length / 10 // gradual shrink for longer ones
//                                 ) + "px",
//                                 lineHeight: "1.2", // keeps spacing consistent
//                             }}>
//                             {currentNews.title}
//                         </IonCardTitle>
//                         <IonCardSubtitle>{currentNews.date}</IonCardSubtitle>
//                     </IonCardHeader>
//                 </IonCardContent>
//             </IonCard> */}
//             <IonCard
//                 color="light"
//                 className="post-card ion-no-margin ion-shadow-sm news-card"
//                 style={{
//                     height: "320px",

//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center" // center everything inside
//                 }}
//             >
//                 <IonCardContent className="ion-padding" style={{ width: "100%", textAlign: "left" }}>
//                     <IonCardHeader>
//                         <IonCardTitle
//                             className="news-title"
//                         >
//                             {currentNews.title}
//                         </IonCardTitle>
//                         <IonCardSubtitle className='news-date'>{currentNews.date}</IonCardSubtitle>
//                     </IonCardHeader>
//                 </IonCardContent>
//             </IonCard>

//         </div>
//     );
// };

// export default RotatingCanadianNews;
// import React, { useEffect, useState } from 'react';
// import { IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonSpinner, IonCardContent } from '@ionic/react';
// import "./CanadianNews.css"
// const CanadianNews = ({ interval = 5000 }) => {
//     const [news, setNews] = useState([]);
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [loading, setLoading] = useState(true);
//     const keywords = [
//         "canada", "alberta", "british columbia", "manitoba", "new brunswick",
//         "newfoundland", "nova scotia", "ontario", "prince edward island",
//         "quebec", "saskatchewan", "yukon", "nunavut", "northwest territories",
//         "toronto", "vancouver", "montreal", "calgary", "edmonton",
//         "ottawa", "winnipeg", "halifax", "victoria", "regina",
//         "saskatoon", "st. john's", "charlottetown", "whitehorse",
//     ];
//     const feeds = [
//         "https://news.google.com/rss?hl=en-CA&gl=CA&ceid=CA:en",
//         "https://globalnews.ca/canada/feed/"
//     ];
//     useEffect(() => {
//         const fetchAllFeeds = async () => {
//             try {
//                 const allItems = [];

//                 for (const feed of feeds) {
//                     const rssUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(feed)}`;
//                     const response = await fetch(rssUrl);
//                     const data = await response.json();

//                     if (data.items) {
//                         const filtered = data.items.filter(item =>
//                             keywords.some(keyword =>
//                                 item.title.toLowerCase().includes(keyword)
//                             )
//                         );
//                         allItems.push(...filtered);
//                     }
//                 }

//                 allItems.sort((a, b) => new Date(b.pubDate) - new Date(a.pubDate));

//                 const topItems = allItems.slice(0, 20).map(item => ({
//                     title: item.title,
//                     date: new Date(item.pubDate).toLocaleDateString(),
//                 }));

//                 setNews(topItems);
//             } catch (error) {
//                 console.error("Error fetching RSS:", error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAllFeeds();
//     }, []);

//     // Rotate news index AFTER news is loaded
//     useEffect(() => {
//         if (news.length === 0) return; // wait until we have news
//         console.log("News", news)
//         const timer = setInterval(() => {
//             setCurrentIndex(prev => (prev + 1) % news.length);
//         }, interval);

//         return () => clearInterval(timer); // cleanup
//     }, [news, interval]); // depend on news length

//     if (loading) return <IonSpinner style={{ margin: "20px auto", display: "block" }} />;

//     if (!news.length) return <p style={{ textAlign: 'center' }}>No Canadian news available.</p>;

//     const currentNews = news[currentIndex];
//     return (
//         <div className="post__side--right post" >
//             <IonCard color="light" className="post-card ion-no-margin ion-shadow-sm">
//                 <IonCardContent className="ion-padding">
//                     <IonCardHeader>
//                         <IonCardTitle className='card-title' >{currentNews.title}</IonCardTitle>
//                         <IonCardSubtitle>{currentNews.date}</IonCardSubtitle>
//                     </IonCardHeader>
//                 </IonCardContent>
//             </IonCard>
//         </div>
//     );
// };

// export default CanadianNews;

// import React, { useEffect, useState } from "react";
// import {
//   IonCard,
//   IonCardHeader,
//   IonCardTitle,
//   IonCardSubtitle,
//   IonSpinner,
//   IonCardContent,
//   IonImg,
//   IonIcon,
// } from "@ionic/react";
// import { flag } from "ionicons/icons";
// import "./CanadianNews.css";
// import { useTranslation } from "react-i18next";

// const CanadianNews = ({ interval = 5000 }) => {
//   const [news, setNews] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const { t } = useTranslation();
//   const keywords = [
//     "canada",
//     "alberta",
//     "british columbia",
//     "manitoba",
//     "new brunswick",
//     "newfoundland",
//     "nova scotia",
//     "ontario",
//     "prince edward island",
//     "quebec",
//     "saskatchewan",
//     "yukon",
//     "nunavut",
//     "northwest territories",
//     "toronto",
//     "vancouver",
//     "montreal",
//     "calgary",
//     "edmonton",
//     "ottawa",
//     "winnipeg",
//     "halifax",
//     "victoria",
//     "regina",
//     "saskatoon",
//     "st. john's",
//     "charlottetown",
//     "whitehorse",
//     "iqaluit",
//   ];

//   const feeds = ["https://globalnews.ca/canada/feed/"];

//   useEffect(() => {
//     const fetchAllFeeds = async () => {
//       try {
//         const allItems = [];
//         for (const feed of feeds) {
//           const rssUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(
//             feed
//           )}`;
//           const response = await fetch(rssUrl);
//           const data = await response.json();
//           if (data.items) {
//             const filtered = data.items
//               // .filter(item => keywords.some(keyword => item.title.toLowerCase().includes(keyword)))
//               .map((item) => ({
//                 title: item.title,
//                 date: new Date(item.pubDate).toLocaleDateString(),
//                 image: item.thumbnail || item.enclosure?.link || null, // check rss2json thumbnail or enclosure
//                 link: item.link,
//               }));
//             allItems.push(...filtered);
//           }
//         }
//         allItems.sort(
//           (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
//         );
//         setNews(allItems.slice(0, 20));
//       } catch (error) {
//         console.error("Error fetching RSS:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchAllFeeds();
//   }, []);

//   useEffect(() => {
//     if (!news.length) return;
//     const timer = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % news.length);
//     }, interval);
//     return () => clearInterval(timer);
//   }, [news, interval]);

//   if (loading)
//     return <IonSpinner style={{ margin: "20px auto", display: "block" }} />;

//   if (!news.length)
//     return (
//       <p style={{ textAlign: "center", fontStyle: "italic" }}>
//         {t("noCanadianNews", "No Canadian news available.")}
//       </p>
//     );

//   const currentNews = news[currentIndex];

//   return (
//     <div className="post__side--right post">
//       <IonCardHeader>
//         <IonCardTitle className="local-header">
//           {"🗞️ " + t("news")}
//         </IonCardTitle>
//       </IonCardHeader>
//       <IonCardContent></IonCardContent>
//       <IonCard
//         className="canadian-news-card ion-no-margin ion-shadow-md"
//         color="light"
//       >
//         {currentNews.image && (
//           <IonImg
//             src={currentNews.image}
//             alt="News Image"
//             style={{
//               width: "100%",
//               aspectRatio: "1 / 1",
//               objectFit: "cover",
//               borderTopLeftRadius: "8px",
//               borderTopRightRadius: "8px",
//             }}
//           />
//         )}
//         <IonCardContent className="ion-padding">
//           <IonCardHeader>
//             <IonIcon
//               icon={flag}
//               style={{ color: "#d32f2f", marginRight: "6px" }}
//             />
//             <IonCardTitle
//               className="card-title poetsen"
//               style={{
//                 fontWeight: "bold",
//                 fontSize: "1.2rem",
//                 color: "#2e2e2e",
//               }}
//             >
//               {currentNews.title}
//             </IonCardTitle>
//             <IonCardSubtitle style={{ fontSize: "0.9rem", color: "#555" }}>
//               {currentNews.date}
//             </IonCardSubtitle>
//           </IonCardHeader>
//           <a
//             href={currentNews.link}
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{
//               display: "inline-block",
//               marginTop: "8px",
//               padding: "6px 12px",
//               backgroundColor: "#d32f2f",
//               color: "#fff",
//               borderRadius: "8px",
//               textDecoration: "none",
//               fontSize: "0.9rem",
//             }}
//             className="poetsen"
//           >
//             {t("readMore")} →
//           </a>
//         </IonCardContent>
//       </IonCard>
//     </div>
//   );
// };

// export default CanadianNews;
// import React, { useEffect, useState } from "react";
// import {
//   IonCard,
//   IonCardHeader,
//   IonCardTitle,
//   IonCardSubtitle,
//   IonSpinner,
//   IonCardContent,
//   IonImg,
//   IonIcon,
// } from "@ionic/react";
// import { flag } from "ionicons/icons";
// import "./CanadianNews.css";
// import { useTranslation } from "react-i18next";
// import { SERVER_URL } from "../../api/client";

// const CanadianNews = ({ interval = 5000 }) => {
//   const [news, setNews] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const { t } = useTranslation();

//   // 1. Fetch from your Express backend
//   useEffect(() => {
//     const fetchNewsFromBackend = async () => {
//       try {
//         // Replace with your actual API endpoint
//         // If your route has 'auth' middleware, ensure you include credentials/headers
//         const response = await fetch(`${SERVER_URL}/api/canadian-news`);
//         const data = await response.json();

//         if (Array.isArray(data)) {
//           // Sort by pubDate (newest first)
//           const sorted = data.sort(
//             (a, b) =>
//               new Date(b.pubDate).getTime() - new Date(a.pubDate).getTime(),
//           );
//           setNews(sorted.slice(0, 20));
//         }
//       } catch (error) {
//         console.error("Error fetching news from backend:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchNewsFromBackend();
//   }, []);

//   // 2. Handle the carousel rotation
//   useEffect(() => {
//     if (news.length <= 1) return;
//     const timer = setInterval(() => {
//       setCurrentIndex((prev) => (prev + 1) % news.length);
//     }, interval);
//     return () => clearInterval(timer);
//   }, [news, interval]);

//   if (loading) {
//     return <IonSpinner style={{ margin: "20px auto", display: "block" }} />;
//   }

//   if (!news.length) {
//     return (
//       <p style={{ textAlign: "center", fontStyle: "italic", padding: "20px" }}>
//         {t("noCanadianNews", "No Canadian news available.")}
//       </p>
//     );
//   }

//   const currentNews = news[currentIndex];

//   return (
//     <div className="post__side--right post">
//       <div className="local-header-container" style={{ padding: "0 16px" }}>
//         <h2 className="local-header" style={{ fontSize: "1.4rem" }}>
//           {"🗞️ " + t("news")}
//         </h2>
//       </div>

//       <IonCard
//         className="canadian-news-card ion-no-margin ion-shadow-md"
//         color="light"
//       >
//         {currentNews.image && (
//           <div
//             style={{
//               position: "relative",
//               overflow: "hidden",
//               aspectRatio: "16/9",
//             }}
//           >
//             <IonImg
//               src={currentNews.image}
//               alt={currentNews.title}
//               style={{ objectFit: "cover", width: "100%", height: "100%" }}
//             />
//           </div>
//         )}

//         <IonCardHeader>
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               marginBottom: "8px",
//             }}
//           >
//             <IonIcon
//               icon={flag}
//               style={{ color: "#d32f2f", marginRight: "8px" }}
//             />
//             <IonCardSubtitle style={{ fontSize: "0.85rem" }}>
//               {new Date(currentNews.pubDate).toLocaleDateString()}
//             </IonCardSubtitle>
//           </div>
//           <IonCardTitle
//             className="card-title poetsen"
//             style={{ fontWeight: "bold", fontSize: "1.1rem", color: "#2e2e2e" }}
//           >
//             {currentNews.title}
//           </IonCardTitle>
//         </IonCardHeader>

//         <IonCardContent>
//           {currentNews.snippet && (
//             <p
//               style={{
//                 fontSize: "0.9rem",
//                 color: "#444",
//                 marginBottom: "12px",
//               }}
//             >
//               {currentNews.snippet.substring(0, 100)}...
//             </p>
//           )}
//           <a
//             href={currentNews.link}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="read-more-button poetsen"
//             style={{
//               display: "inline-block",
//               padding: "8px 16px",
//               backgroundColor: "#d32f2f",
//               color: "#fff",
//               borderRadius: "4px",
//               textDecoration: "none",
//               fontSize: "0.85rem",
//             }}
//           >
//             {t("readMore")} →
//           </a>
//         </IonCardContent>
//       </IonCard>
//     </div>
//   );
// };

// export default CanadianNews;
import React, { useEffect, useState } from "react";
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonSpinner,
  IonCardContent,
  IonImg,
  IonIcon,
} from "@ionic/react";
import { flag } from "ionicons/icons";
import "./CanadianNews.css";
import { useTranslation } from "react-i18next";
import getDate from "../../utils/getDate";
import { useDispatch, useSelector } from "react-redux";
import { fetchLatestNews } from "../../redux/actions/canadaNowActions";

const CanadianNews = ({ interval = 5000 }) => {
  const { news, loading } = useSelector((state) => state.canadaNow);
  const dispatch = useDispatch();
  // const [currentIndex, setCurrentIndex] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    if (!news) {
      dispatch(fetchLatestNews());
    }
  }, [dispatch, news]);

  // useEffect(() => {
  //   if (!news || news.length <= 1) return;
  //   const timer = setInterval(() => {
  //     setCurrentIndex((prev) => (prev + 1) % news.length);
  //   }, interval);
  //   return () => clearInterval(timer);
  // }, [news, interval]);

  if (loading && !news)
    return <IonSpinner style={{ margin: "20px auto", display: "block" }} />;

  if (!news || !news.length)
    return (
      <p style={{ textAlign: "center", fontStyle: "italic", padding: "10px" }}>
        {t("noCanadianNews", "No Canadian news available.")}
      </p>
    );

  // const currentNews = news[currentIndex];
  return (
    <div className="post__side--right post">
      <IonCardHeader>
        <IonCardTitle className="local-header">
          {"🗞️ " + t("news")}
        </IonCardTitle>
      </IonCardHeader>
      {news.map((item, index) => (
        <IonCard
          className="canadian-news-card ion-no-margin ion-shadow-md"
          style={{ marginBottom: "10px" }}
          color="light"
          key={index}
        >
          {item.image && (
            <IonImg
              src={item.image}
              alt="News Image"
              style={{
                width: "100%",
                aspectRatio: "1 / 1",
                objectFit: "cover",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
              }}
            />
          )}
          <IonCardContent className="ion-padding">
            <IonCardHeader>
              <IonIcon
                icon={flag}
                style={{ color: "#d32f2f", marginRight: "6px" }}
              />
              <IonCardTitle
                className="card-title poetsen"
                style={{
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "#2e2e2e",
                }}
              >
                {item.title}
              </IonCardTitle>
              <IonCardSubtitle
                style={{
                  fontSize: "0.9rem",
                  color: "#555",
                  marginTop: "8px",
                }}
              >
                {getDate(item.pubDate)}
                {" · "}
                Global News
              </IonCardSubtitle>
            </IonCardHeader>
            <a
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                marginTop: "8px",
                padding: "6px 12px",
                backgroundColor: "#d32f2f",
                color: "#fff",
                borderRadius: "8px",
                textDecoration: "none",
                fontSize: "0.9rem",
              }}
              className="poetsen"
            >
              {t("readMore")} →
            </a>
          </IonCardContent>
        </IonCard>
      ))}
    </div>
  );
};

export default CanadianNews;
